import {Component, Input, OnInit} from '@angular/core';
import {Dossiers} from '../../services';

@Component({
  selector: 'app-state-chip',
  templateUrl: './state-chip.component.html',
  styleUrls: ['./state-chip.component.scss']
})
export class StateChipComponent implements OnInit {
  @Input() dossier: Dossiers;
  @Input() align: 'start' | 'end' = 'end';
  constructor() { }

  ngOnInit(): void {
  }
  /**
   * Couleur des boutons de validation selon l'état
   * Définis dans ~/styles-p8.css
   */
  public colorChip() {
    if (this.dossier) {
      return `dar-${this.dossier.state}`;
    }
    return '';
  }
  /**
   * Libellé de l'état courant du dossier
   */
  public stateLabel() {
    if (this.dossier && this.dossier.state_title) {
      return this.dossier.state_title;
    }

    return 'Nouvelle demande';
  }
}
